import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { CancelBookingInitStepDeclaration } from "./Steps/CancelBookingInitStep";
import { CancelBookingTransition } from "./Transition/CancelBookingTransition";

export const cancelBookingMainStartupFlow = new FlowDefinition("CancelBookingFlow");

cancelBookingMainStartupFlow.addStep(CancelBookingInitStepDeclaration);

//cancelBookingMainStartupFlow.addTransition(CancelBookingTransition, "CancelBookingInit_Step")

cancelBookingMainStartupFlow.setStartStep("CancelBookingInit_Step");

export const cancelBookingStepDefinition = new StepDefinition({
    stepName: "CancelBookingFlow",
    stepFlow: cancelBookingMainStartupFlow,
    contextIsolation: false
})
